import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { Store } from 'vuex';
import store from './store';
import vue3lottie from 'vue3-lottie';

// common
import gBtn from '@/components/common/TPCommonButton.vue';
import gBtnList from '@/components/common/TPCommonButtonList.vue';
import gInput from '@/components/common/TPCommonInput.vue';
import gIcon from '@/components/common/TPCommonIcon.vue';
import gPopwrap from '@/components/common/layouts/TPPopLayout.vue';
import TPConst from '@/types/TPConst'

// introduction
import mainTitle from './components/introduction/C_Ctp_title.vue';

const app = createApp(App);

app
  .use(store)
  .use(router)
  .use(TPConst)
  .use(vue3lottie)
  .component("gBtn", gBtn)
  .component("gBtnList", gBtnList)
  .component("gInput", gInput)
  .component("gIcon", gIcon)
  .component("gPopwrap", gPopwrap)
  .component("mainTitle", mainTitle);

app.config.globalProperties.$store = store;
app.config.globalProperties.$gTPConst = TPConst

app.mount('#app');

declare module 'vue' {
  interface ComponentCustomProperties {
    $store: Store<any>;
  }
}
